import React from 'react';
import type { Event } from '@/types/event';
import { Button } from '../basic/Button';

interface ActionSectionProps {
  event: Event;
  onReserve: () => void;
  onClose: () => void;
  isRegistered: boolean;
}

const ActionSection: React.FC<ActionSectionProps> = ({ event, onReserve, onClose, isRegistered = false }) => {
  const isReserved = event.is_reserved || isRegistered;

  const handleReserve = () => {
    if (isReserved) {
      onClose();
    } else {
      onReserve();
    }
  };

  return (
    <div className="w-full space-y-3 sm:space-y-4 pb-4 sm:pb-6">
      <Button
        onClick={handleReserve}
        disabled={isReserved}
        variant={isReserved ? 'secondary' : 'primary'}
        size="lg"
        className="w-full text-sm sm:text-base"
      >
        {isReserved ? 'Reserved' : 'Reserve Now'}
      </Button>

      <Button
        onClick={onClose}
        variant="outline"
        size="lg"
        className="w-full text-sm sm:text-base"
      >
        {isReserved ? 'Close' : 'Maybe Later'}        
      </Button>
    </div>
  );
};

export default ActionSection;